var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5282 18.5615L11.2282 12.2615C10.7282 12.6615 10.1532 12.9782 9.50322 13.2115C8.85322 13.4449 8.16156 13.5615 7.42822 13.5615C5.61156 13.5615 4.07406 12.9324 2.81572 11.674C1.55739 10.4157 0.928223 8.87819 0.928223 7.06152C0.928223 5.24486 1.55739 3.70736 2.81572 2.44902C4.07406 1.19069 5.61156 0.561523 7.42822 0.561523C9.24489 0.561523 10.7824 1.19069 12.0407 2.44902C13.2991 3.70736 13.9282 5.24486 13.9282 7.06152C13.9282 7.79486 13.8116 8.48652 13.5782 9.13652C13.3449 9.78652 13.0282 10.3615 12.6282 10.8615L18.9282 17.1615L17.5282 18.5615ZM7.42822 11.5615C8.67822 11.5615 9.74072 11.124 10.6157 10.249C11.4907 9.37402 11.9282 8.31152 11.9282 7.06152C11.9282 5.81152 11.4907 4.74902 10.6157 3.87402C9.74072 2.99902 8.67822 2.56152 7.42822 2.56152C6.17822 2.56152 5.11572 2.99902 4.24072 3.87402C3.36572 4.74902 2.92822 5.81152 2.92822 7.06152C2.92822 8.31152 3.36572 9.37402 4.24072 10.249C5.11572 11.124 6.17822 11.5615 7.42822 11.5615Z",
    fill: "#3D4910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c3dc29c7a3fa72786f2781bc3cb35e60.svg";
export { ForwardRef as ReactComponent };